import * as React from "react";
import styles from "./modal-image-component.module.scss";
// import LazyImage from "../../lazy-image/lazy-image";
import { transformImage } from "../../../utils";
import { getUserAgent } from "../../../utils/agent";
import { IUserAgent } from "../../../types/ua";
const icon = "https://site.appchoose.io/external/icons/ic-close-black.svg";
interface IModalImageComponent {
  images: string[];
  focusOn?: number;
  onClose: any;
  imageClassName?: string;
}

export default class ModalImageComponent extends React.PureComponent<
  IModalImageComponent,
  any
> {
  public ref: HTMLDivElement;
  public focused = this.props.focusOn || 0;

  public state = {
    userAgent: {} as IUserAgent,
  };

  public componentDidMount() {
    this.focusOnImg();
    const userAgent = getUserAgent();
    this.setState({
      userAgent,
    });
    document.addEventListener("keydown", this.onPressKeyDown);
  }

  public componentWillUnmount() {
    document.removeEventListener("keydown", this.onPressKeyDown);
  }

  public focusOnImg = () => {
    const imgs = this.ref.querySelectorAll("img");
    const elt = imgs[this.focused];
    if (elt && typeof elt.scrollIntoView === "function") {
      elt.scrollIntoView({
        block: "center",
      });
    }
  };

  public onPressKeyDown = (event: any) => {
    switch (event.keyCode) {
      case 27:
        if (typeof this.props.onClose === "function") {
          this.props.onClose();
        }
        break;
      case 40:
      case 39:
        event.preventDefault();
        this.focused =
          this.focused >= this.props.images.length - 1
            ? this.props.images.length - 1
            : this.focused + 1;
        this.focusOnImg();
        break;
      case 38:
      case 37:
        event.preventDefault();
        this.focused = this.focused <= 0 ? 0 : this.focused - 1;
        this.focusOnImg();
        break;
      default:
        break;
    }
  };

  public onClose = () => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  get renderImages() {
    return this.props.images.map((image: string, idx: number) => {
      return (
        <img
          className={this.props.imageClassName}
          onClick={this.onClickImage}
          key={`${image}-${idx}`}
          src={transformImage(
            image,
            "1500x",
            undefined,
            this.state.userAgent.hasWebp
          )}
          alt="Image produit"
        />
      );
    });
  }

  public onClickImage = (event: any) => {
    event.stopPropagation();
  };
  public onLoad = () => {
    this.focusOnImg();
  };

  public render() {
    return (
      <div className={styles.modal} onClick={this.onClose}>
        <a className={styles.close}>
          <img alt="close" src={icon} />
        </a>
        <div
          ref={(c) => {
            if (c) {
              this.ref = c;
            }
          }}
          className={`container ${styles.image}`}
          onLoad={this.onLoad}
        >
          {this.renderImages}
        </div>
      </div>
    );
  }
}
